export enum Size {
  REGULAR = 1.5,
  LARGE = 2
}
